import React, {memo} from 'react'

import {useAccordion} from './hooks'
import {DetailsProps} from './types'

const AccordionDetails = memo<DetailsProps>(({'data-testid': dataTestId, children, className}) => {
  const {isExpanded} = useAccordion()

  return isExpanded ? (
    <div className={className} data-testid={dataTestId}>
      {children}
    </div>
  ) : null
})

AccordionDetails.displayName = 'AccordionDetails'

export {AccordionDetails}
